{
  "version": 1,
  "asset_id": "77b46122-6596-45b3-926c-57134af66eb2",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/77b46122-6596-45b3-926c-57134af66eb2/beverly-hills-shingle-roof-tear-off-1280w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/77b46122-6596-45b3-926c-57134af66eb2/beverly-hills-shingle-roof-tear-off-1280w.webp",
  "original_filename": "beverly-hills-shingle-roof-tear-off-1280w.webp",
  "size": 208422,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:12Z"
}
